import { FC } from 'react';
import { Outlet } from 'react-router';
import { Header } from './Header';

import styles from './styles.module.css';

export const Layout: FC = () => {
    return (
        <div className={styles.layout}>
            <Header />
            <div className={styles.main}>
                <Outlet />
            </div>
        </div>
    );
};
